import React from 'react';
import { FilterItem, FiltersList } from '../common/Showtimes/ShowtimesBlockCinemaFilters';
import BackButton from '../common/BackButton';
import styled from 'styled-components';
import { breakpoints } from '../../utils/styles';

const Container = styled.div`
    display: flex;
    justify-content: space-between;

    @media screen and (min-width: ${breakpoints.desktop}px) {
        justify-content: flex-start;
    }
`;

interface Props {
    title: string;
    onAreaChangeClick?: () => void;
    onCinemasEdit?: () => void;
    onTimeEdit?: () => void;
    onFiltersShowClick?: () => void;
}

const BillboardHeading: React.FC<Props> = (props) => {
    return (
        <Container className='container pad-y d-md-none'>
            <BackButton label={props.title} backTo='/' />
            <div style={{ marginTop: '0.25rem' }}>
                <FiltersList>
                    {props.onAreaChangeClick && <FilterItem muted={false}><i className="fal fa-pencil" onClick={props.onAreaChangeClick}></i> </FilterItem>}
                    {props.onCinemasEdit && <FilterItem muted={false}><i className="fal fa-pencil" onClick={props.onCinemasEdit}></i> </FilterItem>}
                    {props.onTimeEdit && <FilterItem muted={false}><i className="fal fa-filter" onClick={props.onTimeEdit}></i> </FilterItem>}
                    {props.onFiltersShowClick && <FilterItem muted={false}><i className="fal fa-filter d-inline-block d-md-none" onClick={props.onFiltersShowClick}></i> </FilterItem>}
                </FiltersList>
            </div>
        </Container>
    )
}

export default BillboardHeading;